import { db } from "./firebase";
import {
  ref,
  push,
  set,
  onValue,
  remove,
  update
} from "firebase/database";

// ---------- SUBJECTS ----------

export const addSubject = async (subject) => {
  const newRef = push(ref(db, "subjects"));
  await set(newRef, subject);
};

export const getSubjects = (callback) => {
  onValue(ref(db, "subjects"), (snapshot) => {
    const data = snapshot.val() || {};

    callback(
      Object.keys(data).map((id) => ({
        id,
        ...data[id],
      }))
    );
  });
};

export const deleteSubject = async (id) => {
  await remove(ref(db, "subjects/" + id));
};

export const updateSubject = async (id, subjectData) => {
  await update(ref(db, "subjects/" + id), subjectData);
};

// ---------- TEACHERS ----------

export const addTeacher = async (teacher) => {
  const newRef = push(ref(db, "teachers"));

  await set(newRef, {
    ...teacher,
    createdAt: Date.now(),
  });
};

export const getTeachers = (callback) => {
  onValue(ref(db, "teachers"), (snapshot) => {
    const data = snapshot.val() || {};

    callback(
      Object.keys(data).map((id) => ({
        id,
        ...data[id],
      }))
    );
  });
};

export const deleteTeacher = async (id) => {
  await remove(ref(db, "teachers/" + id));
};

export const updateTeacher = async (id, teacherData) => {
  await update(ref(db, "teachers/" + id), teacherData);
};

// ---------- CLASSES ----------

export const addClass = async (classData) => {
  const newRef = push(ref(db, "classes"));

  await set(newRef, classData);
};

export const getClasses = (callback) => {
  onValue(ref(db, "classes"), (snapshot) => {
    const data = snapshot.val() || {};

    callback(
      Object.keys(data).map((id) => ({
        id,
        ...data[id],
      }))
    );
  });
};

export const deleteClass = async (id) => {
  await remove(ref(db, "classes/" + id));
};

export const updateClass = async (id, classData) => {
  await update(ref(db, "classes/" + id), classData);
};

// ---------- TIMETABLE ----------

export const saveTimetable = async (className, timetable) => {
  await set(ref(db, "timetables/" + className), timetable);
};

export const getTimetable = (className, callback) => {
  onValue(ref(db, "timetables/" + className), (snapshot) => {
    callback(snapshot.val() || {});
  });
};

// ---------- TEACHER STATUS ----------

export const updateTeacherStatus = async (date, teacherName, statusData) => {
  await update(ref(db, `teacherStatus/${date}/${teacherName}`), statusData);
};

export const getTeacherStatus = (date, callback) => {
  onValue(ref(db, `teacherStatus/${date}`), (snapshot) => {
    callback(snapshot.val() || {});
  });
};

// ---------- ARRANGEMENTS ----------

export const saveArrangements = async (date, arrangements) => {
  await set(ref(db, `arrangements/${date}`), arrangements);
};

export const getArrangements = (date, callback) => {
  onValue(ref(db, `arrangements/${date}`), (snapshot) => {
    callback(snapshot.val() || []);
  });
};

// ---------- ARRANGEMENT HISTORY ----------

export const saveArrangementHistory = async (date, arrangementId, data) => {
  await set(ref(db, `arrangementHistory/${date}/${arrangementId}`), data);
};

export const getArrangementHistory = (date, callback) => {
  onValue(ref(db, `arrangementHistory/${date}`), (snapshot) => {
    const data = snapshot.val() || {};
    const historyArray = Object.keys(data).map((key) => ({
      id: key,
      ...data[key]
    }));
    callback(historyArray);
  });
};

// ---------- SHARED SUBJECTS ----------

export const getSharedSubjects = (callback) => {
  onValue(ref(db, "sharedSubjects"), (snapshot) => {
    const data = snapshot.val() || [];
    callback(data);
  });
};

export const updateSharedSubjects = async (subjects) => {
  await set(ref(db, "sharedSubjects"), subjects);
};